import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { JSProxyService } from './services/jsproxy.service';
import { UsersService } from "./services/users.service";
import { ToastrService } from "ngx-toastr";
import { ExcelService } from './services/ExcelService';

declare var Loc: any;
declare var StoreService: any;

@Component({
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent implements OnInit {
  translate: TranslateService;
  jsProxyService: JSProxyService;
  toastService: ToastrService;
  usersService: UsersService;
  excelService: ExcelService;

  constructor(translate: TranslateService,
    usersService: UsersService,
    toastService: ToastrService,
    jsProxyService: JSProxyService,
    excelService: ExcelService/*!init excel!*/) {
    this.translate = translate;
    this.toastService = toastService;
    this.usersService = usersService;

    this.jsProxyService = jsProxyService;
    this.excelService = excelService;
  }

  ngOnInit() {
    const isMobile = () => {
      if (typeof navigator === 'undefined') return false;
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    if (!isMobile()) {
      if (Loc)
        Loc.service = this.translate;
      StoreService = this.jsProxyService;
    }

    this.jsProxyService.registerComponent("Toaster", this.toastService, "");
    this.jsProxyService.registerComponent("Profile", this.usersService, "");
  }

}
